// ===== Scroll to Top ====
(function scrollTop($, Drupal) {
    Drupal.behaviors.scrolltop = {
        attach: function (context, settings) {
            var $scroll_top_link = $("#scroll-top");
            // $scroll_top_link
            $(window).scroll(function() {
                if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px

                    $scroll_top_link.fadeIn(400);    // Fade in the arrow
                } else {
                    $scroll_top_link.fadeOut(400);   // Else fade out the arrow
                }
            });
            $scroll_top_link.click(function() {      // When arrow is clicked
                $('body,html').animate({
                    scrollTop : 0                       // Scroll to top of body
                }, 500);
            });
        },
    };
}(jQuery, Drupal));
